var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle-svgrepo-com (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.5,
    d: "M11.9084 21.8334C17.3893 21.8334 21.8324 17.3903 21.8324 11.9094C21.8324 6.42849 17.3893 1.98535 11.9084 1.98535C6.42751 1.98535 1.98438 6.42849 1.98438 11.9094C1.98438 17.3903 6.42751 21.8334 11.9084 21.8334Z",
    stroke: "#1C274C",
    strokeWidth: 1.4886
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3898 9.42873L9.42775 14.3907M9.42773 9.42871L14.3898 14.3907",
    stroke: "#1C274C",
    strokeWidth: 1.4886,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modalClose.44f3845e36fd52b737d4ec1cf4e0adb3.svg";
export { ForwardRef as ReactComponent };